document.addEventListener("DOMContentLoaded", () => {
  const grandParents = document.querySelectorAll(".grandparent");

  grandParents.forEach((gp) => {
    gp.addEventListener("mouseenter", () => {
      gp.classList.add("hover");
    });

    gp.addEventListener("mouseleave", () => {
      gp.classList.remove("hover");
    });
  });
});
